import * as React from "react";
import styled from "styled-components";

import { FooterContent, StyledAnchor } from "../styles";
import Feedback from "../Feedback";
import { SLACK_LINK } from "../../utils/constants";

const FeedbackLabel = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 0.2rem;
	margin-bottom: 0.1rem;
`;

const Footer: React.FC = () => {
	return (
		<footer id="flagga-footer">
			<div className="page-container">
				<div className="page-container__inner">
					<FooterContent className="page-container__main">
						<span>
							Please contact us in{" "}
							<StyledAnchor
								href={SLACK_LINK}
								target="_blank"
								aria-label="Open #cssom-flagga Slack channel in a new tab"
							>
								#cssom-flagga
							</StyledAnchor>{" "}
							for any questions!
						</span>
						<FeedbackLabel id="feedbackTitle">How did we do?</FeedbackLabel>
						<Feedback showRating={true} />
					</FooterContent>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
